module.exports = __webpack_public_path__ + "static/media/sbb-logo.449b58fd.jpeg";